export const GET_CAMPAIGNS_REQUEST = "GET_CAMPAIGNS_REQUEST"
export const GET_CAMPAIGNS_SUCCESS = "GET_CAMPAIGNS_SUCCESS"
export const GET_CAMPAIGNS_FAILED = "GET_CAMPAIGNS_FAILED"

export const GET_OVERVIEW_REQUEST = "GET_OVERVIEW_REQUEST"
export const GET_OVERVIEW_SUCCESS = "GET_OVERVIEW_SUCCESS"
export const GET_OVERVIEW_FAILED = "GET_OVERVIEW_FAILED"

export const GetCampaignsAction = (startDate: any, endDate: any)=>{
    return{
        type:GET_CAMPAIGNS_REQUEST,payload: { startDate,  endDate }
    }
}

export const GetOverviewAction = ()=>{
    return{
        type:GET_OVERVIEW_REQUEST,
    }
}